import { gql } from '@apollo/client';

export const fetchTermPaymentAuditTrails = gql`
  query fetchTermPaymentAuditTrails(
    $searchParams: TermPaymentAuditTrailSearchParams
    $searchOptions: TermPaymentAuditTrailsSearchOptions
  ) {
    termPaymentAuditTrails(searchParams: $searchParams, searchOptions: $searchOptions) {
      totalCount
      nodes {
        id
        comments
        updatedBy
        createdAt
        revisionNumber
        revisionType
      }
    }
  }
`;
